<template>
    <FullScreenModal ref="modal" class="preview-modal" @closed="onClose">
        <template v-slot:body>
            <iframe v-show="initDone" class="preview-container" v-if="!!url" :src="url" @load="loaded" />
            <div
                class="preview-container is-flex is-justify-content-center is-align-items-center is-flex-direction-column"
                v-if="!initDone"
            >
                <div class="mb-5">
                    <h1 class="title">
                        {{ translate("common.loading") }}
                    </h1>
                </div>
                <div>
                    <LoadingSpinner2 />
                </div>
            </div>
        </template>
    </FullScreenModal>
</template>

<script>
    import FullScreenModal from "../../Common/FullScreenModal.vue";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2.vue";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "payment-document-preview-modal",
        components: { LoadingSpinner2, FullScreenModal },
        mixins: [translatorMixin],
        data() {
            return {
                url: "",
                initDone: false,
            };
        },
        methods: {
            open(url) {
                this.initDone = false;
                this.url = url;

                this.$refs.modal.open();
            },
            loaded() {
                this.initDone = true;
            },
            onClose() {
                this.url = "";
            },
        },
    };
</script>

<style scoped>
    .preview-container {
        height: calc(100vh - 160px);
        width: 100%;
    }
</style>
